import { axios } from 'lib';
import { useQuery } from 'react-query';

const defaultQueryParams = {
  queryKey: ['file-preview'],
  queryOptions: {},
};

const previewFile = async (directID, fileId, tcID = null) => { 
  const url = tcID ? `/api/directs/${directID}/suppliers/${tcID}/files/${fileId}` : `/api/directs/${directID}/files/${fileId}`;
  const {
    data: { data },
  } = await axios.get(url);

  return data;
};

export const useFilePreview = ({directID, fileId, tcID = null, queryParams = {}}) => {
  const { queryKey, queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  return useQuery([...queryKey, fileId], () => previewFile(directID, fileId, tcID), {
    initialData: { url: '', name: '', file_ext: '', mime_type: '' },
    enabled: !!fileId,
    select: ({ url, name, file_ext: FileExt, mime_type: MimeType }) => ({ url, name, FileExt, MimeType }),
    ...queryOptions,
  });
};
